export default "__VITE_ASSET__cm84srwC__"